import React from 'react'

function Icon({ width = 41, height = 11 }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none"
      viewBox="0 0 82 22"
    >
      <path
        stroke="currentColor"
        strokeWidth="2"
        d="M1 11C19.667-2.333 26.333-2.333 21 11c-5.333 13.333 1.333 13.333 20 0s25.333-13.333 20 0c-5.333 13.333 1.333 13.333 20 0"
      ></path>
    </svg>
  )
}

export default Icon
